import { render, staticRenderFns } from "./AccessibilityPlugin.vue?vue&type=template&id=63f323db&scoped=true"
import script from "./AccessibilityPlugin.vue?vue&type=script&lang=js"
export * from "./AccessibilityPlugin.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityPlugin.vue?vue&type=style&index=0&id=63f323db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f323db",
  null
  
)

export default component.exports